export type FluctuationType = 'up' | 'stay' | 'down' | 'new'

export const EnterpriseSortType = {
  MATCHING_RATE: 'matchingRate',
  CREATED_AT: 'createdAt',
  NAME: 'name',
} as const

export type EnterpriseSortTypeValue =
  (typeof EnterpriseSortType)[keyof typeof EnterpriseSortType]

export const EnterpriseSortTypeLabel: { [key: string]: string } = {
  [EnterpriseSortType.MATCHING_RATE]: 'マッチング率順',
  [EnterpriseSortType.CREATED_AT]: '新着順',
  [EnterpriseSortType.NAME]: '名前順',
}
